import { CIMSSingleColumn } from 'components/CIMSTable/CIMSColumn/types'
import { Submittal } from '../../../../../SubmittalTrackerContext/types'
import { Button, Tooltip } from 'antd'
import {
  CASStatus,
  alphabeticalCompare,
  alphabeticalSort,
} from '@cims-online/shared'
import { useSubmittalTrackerContext } from '../../../../../SubmittalTrackerContext'
import { HelpMessage } from 'utils/constants'

export function useStatus(): CIMSSingleColumn<Submittal> {
  const {
    permissions,
    canAdvance,
    actionModal: { toggle },
  } = useSubmittalTrackerContext()
  return {
    title: 'Status',
    help: HelpMessage.CAS.SubmittalTracker.Status,
    render: (record) => {
      const status = CASStatus.fromIdOrFail(record.statusId)
      const { deleted, casToCASRoutingGroups } = record

      if (canAdvance(status, casToCASRoutingGroups))
        return (
          <Button
            type="link"
            disabled={deleted}
            style={{
              padding: 0,
              whiteSpace: 'break-spaces',
              verticalAlign: 'top',
              height: '100%',
            }}
            onClick={() => toggle(record)}
          >
            {status.name}
          </Button>
        )
      return (
        <Tooltip
          title={
            permissions.canGroupReview && status === CASStatus.GroupReview
              ? `All Routing Groups must be accepted to advance to ${CASStatus.REReview.name}`
              : undefined
          }
        >
          {status.name}
        </Tooltip>
      )
    },
    width: 130,
    filter: {
      with: 'items',
      items: CASStatus.sort(alphabeticalSort('priority')).map(
        ({ name, id, description }) => ({
          text: name,
          value: id,
          tooltip: description,
        })
      ),
      key: 'statusId',
    },
    sort: {
      default: 'ascend',
      priority: 1,
      with: 'callback',
      onCompare: (a, b) => {
        const A = CASStatus.fromIdOrFail(a.statusId)
        const B = CASStatus.fromIdOrFail(b.statusId)
        return alphabeticalCompare(A, B, 'priority')
      },
    },
  }
}
